import styled from 'styled-components'

export const ViewerContainer = styled.div<{
  $height?: string
  $width?: string
}>`
  width: ${({ $width }) => $width || '100%'};
  height: ${({ $height }) => $height || '100%'};
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background.tertiary};
  position: relative;
  overflow: hidden;
`

export const PDFContainer = styled.div<{
  $isLoading: boolean
  $hasToolbar?: boolean
}>`
  display: ${({ $isLoading }) => ($isLoading ? 'none' : 'flex')};
  flex-direction: column;
  flex: 1;
  overflow: auto;
  background: ${({ theme }) => theme.colors.background.tertiary};

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.border.default};
    border-radius: ${({ theme }) => theme.borderRadius.small};

    &:hover {
      background: ${({ theme }) => theme.colors.text.tertiary};
    }
  }

  /* react-pdf specific styles */
  .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100%;
  }

  .react-pdf__Page {
    margin: ${({ theme }) => theme.spacing.medium} 0;
    box-shadow: ${({ theme }) => theme.shadows.lg};
    background: white;
  }

  .react-pdf__Page__canvas {
    height: auto !important;
  }

  .react-pdf__Page__textContent {
    /* Remove max-width to allow zooming beyond container */

    /* Search highlight styles */
    mark.pdf-search-highlight {
      background-color: rgba(255, 235, 59, 0.3);
      color: inherit;
      padding: 0;
      border-radius: 2px;
    }

    mark.pdf-search-highlight-current {
      background-color: rgba(33, 150, 243, 0.25);
      color: inherit;
      padding: 0;
      border-radius: 2px;
      outline: 2px solid ${({ theme }) => theme.colors.primary};
    }
  }

  .react-pdf__Page__annotations {
    /* Remove max-width to allow zooming beyond container */
  }
`

export const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: ${({ theme }) => theme.spacing.medium};
  width: 100%;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: ${({ theme }) => theme.spacing.medium};
  background: ${({ theme }) => theme.colors.background.secondary};
`

export const LoadingText = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const LoadingSkeleton = styled.div`
  width: 80%;
  max-width: 600px;
  height: 400px;
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.large};
  background: ${({ theme }) => theme.colors.background.secondary};
  text-align: center;
`

export const ErrorTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.danger};
  margin: 0;
`

export const ErrorMessage = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  max-width: 500px;
`

export const RetryButton = styled.button`
  padding: ${({ theme }) => `${theme.spacing.small} ${theme.spacing.large}`};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.text.inverse};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  cursor: pointer;
  transition: background ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.primaryHover};
  }

  &:active {
    transform: translateY(1px);
  }
`
